




















































































import Vue from 'vue';
import CustomerLogin from '@/components/CustomerLogin.vue';
import LoginMarketing from '@/components/LoginMarketing.vue';
import portalMixin from '@/mixins/portalMixin';
import Customer from '@/models/Customer';

export default Vue.extend({
	name: 'LoginModal',
	components: {
		CustomerLogin,
		LoginMarketing,
	},
	mixins: [portalMixin],
	props: {
		hidden: Boolean,
		idPrefix: String,
		isReservationProcess: Boolean,
		lockLocation: Boolean,
		loginClass: { type: String, default: 'np-button np-button--primary np-button--sm' },
		loginText: { type: String, default: 'Have an account? Sign In' },
		loggedInClass: String,
		loggedInText: { type: String, default: '' },
		logout: Boolean,
		redirect: Boolean,
		register: Boolean,
		registerClass: { type: String, default: 'np-button np-button--primary np-button--sm' },
	},
	computed: {
		customer(): Customer {
			return this.$store.getters.customer;
		},

		isLoggedIn(): boolean {
			return this.$store.getters.isLoggedIn;
		},

		loginMarketing(): String {
			return this.$store.state.loginMarketing || '';
		},

		maxWidth(): Number {
			return this.showMarketing ? 800 : 400;
		},

		paths(): App.Paths {
			return this.$store.state.paths;
		},

		settings(): Locations.Settings {
			return this.$store.getters['location/settings'];
		},

		showMarketing(): boolean {
			return this.loginMarketing.length > 0;
		},
	},
	watch: {
		isLoggedIn(value: boolean) {
			if (value) {
				this.$modal.hide(`${this.idPrefix}-login-modal`);
			}

			// Check if we used a temp password and if so, redirect to reset
			// password page.
			if (value && this.customer.usedTempPassword) {
				window.location.replace(this.paths.reset);
			}

			// Check if we are on the register page when logging in and
			// redirect to the profile page
			if (value
					&& (this.redirect || window.location.href.toLowerCase().includes(this.paths.register.toLowerCase()))
			) {
				window.location.replace(this.paths.profile);
			}
		},
	},

	methods: {
		signInPressed() {
			this.$store.dispatch('googleEvents/genericButtonPressed', {
				buttonName: 'signIn',
				fromInfo: '',
			});
			this.$modal.show(`${this.idPrefix}-login-modal`);
		},

		registerPressed() {
			this.$store.dispatch('googleEvents/genericButtonPressed', {
				buttonName: 'register',
				fromInfo: '',
			});
			window.location.href = this.paths.register;
		},

		viewProfile() {
			this.$store.dispatch('googleEvents/genericButtonPressed', {
				buttonName: 'viewProfile',
				fromInfo: '',
			});
			window.location.href = this.paths.profile;
		},

		signOutPressed() {
			this.$store.dispatch('googleEvents/genericButtonPressed', {
				buttonName: 'signOut',
				fromInfo: '',
			});
			window.location.href = this.paths.logout;
		},

		continueAsGuest() {
			this.$store.dispatch('googleEvents/genericButtonPressed', {
				buttonName: 'continueAsGuest',
				fromInfo: '',
			});
			this.$modal.hide(`${this.idPrefix}-login-modal`);
		},
	},
});
